import { ALL_APPS, ALL_VIEWS } from 'constants/appConstants';
import PermissionsRouteWrapper from 'views/pages/components/PermissionsRouteWrapper';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import FullHeightMainCardWrapper from 'layout/MainLayout/FullHeightMainCardWrapper';

const Cart = Loadable(lazy(() => import('views/simplifiedPurchasing/Cart')));
const Order = Loadable(lazy(() => import('views/simplifiedPurchasing/Order')));
const OrdersDashboard = Loadable(
  lazy(() => import('views/simplifiedPurchasing/OrdersDashboard'))
);
const Orders = Loadable(
  lazy(() => import('views/simplifiedPurchasing/Orders'))
);
const SupplierOrders = Loadable(
  lazy(() => import('views/simplifiedPurchasing/SupplierOrders'))
);
const SupplierOrder = Loadable(
  lazy(() => import('views/simplifiedPurchasing/SupplierOrder'))
);

export const SimplifiedOrdersRoutes = [
  {
    path: `${ALL_APPS.SIMPLIFIED_BUYING_ORDERS.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.SIMPLIFIED_BUYING_ORDERS.id,
        }}
      >
        <Navigate to={ALL_VIEWS.ALL_ORDERS.path ?? ''} replace />
      </PermissionsRouteWrapper>
    ),
  },

  // Dashboard
  {
    path: `${ALL_VIEWS.ORDERS_DASHBOARD.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{ app: ALL_APPS.SIMPLIFIED_BUYING_ORDERS.id }}
      >
        <OrdersDashboard />
      </PermissionsRouteWrapper>
    ),
  },
  // Open Cart Detail View
  {
    path: `${ALL_VIEWS.OPEN_CART.path}/:purchaseRequestGroupId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{ app: ALL_APPS.SIMPLIFIED_BUYING_ORDERS.id }}
      >
        <Cart />
      </PermissionsRouteWrapper>
    ),
  },
  // Ordered Carts
  {
    path: `${ALL_VIEWS.ALL_ORDERS.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{ app: ALL_APPS.SIMPLIFIED_BUYING_ORDERS.id }}
        >
          <Orders />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.ALL_ORDERS.path}/:purchaseRequestGroupId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{ app: ALL_APPS.SIMPLIFIED_BUYING_ORDERS.id }}
      >
        <Order />
      </PermissionsRouteWrapper>
    ),
  },
  // Supplier Orders
  {
    path: `${ALL_VIEWS.SUPPLIER_ORDERS.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{ app: ALL_APPS.SIMPLIFIED_BUYING_ORDERS.id }}
        >
          <SupplierOrders />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.SUPPLIER_ORDERS.path}/:purchaseId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{ app: ALL_APPS.SIMPLIFIED_BUYING_ORDERS.id }}
      >
        <SupplierOrder />
      </PermissionsRouteWrapper>
    ),
  },
];
